/**
 * 网格骨架占位(首屏加载态,非纯转圈,UX-DR35)。
 */
export function GridSkeleton({ count = 10 }: { count?: number }) {
  return (
    <section className="grid-cards" aria-busy="true">
      {Array.from({ length: count }).map((_, i) => (
        <div className="product-card" key={i}>
          <div className="cover skeleton" />
          <div className="meta">
            <div className="skeleton" style={{ height: 14, marginBottom: 8 }} />
            <div className="skeleton" style={{ height: 14, width: '60%' }} />
          </div>
        </div>
      ))}
    </section>
  );
}
